import { Fragment } from "react";
import { MjmlColumn, MjmlDivider, MjmlRaw, MjmlSection, MjmlText } from "@faire/mjml-react";
import type { SurveyAnswersNode } from "../../nodes/survey-answers/survey-answers-node";

export function $transformSurveyAnswersNode(node: SurveyAnswersNode): React.JSX.Element {
  const qFontWeight = node.getQuestionBold() ? "bold" : "normal";
  const qFontStyle = node.getQuestionItalic() ? "italic" : "normal";
  const qColor = node.getQuestionColor();
  const aFontWeight = node.getAnswerBold() ? "bold" : "normal";
  const aFontStyle = node.getAnswerItalic() ? "italic" : "normal";
  const aColor = node.getAnswerColor();
  const showDivider = node.getDivider();
  const key = "survey-answers";

  return (
    <Fragment key={key}>
      <MjmlRaw
        key={`${key}-each-open`}
        dangerouslySetInnerHTML={{ __html: `{{#each survey_result_${node.getSurveyId()}}}` }}
      />
      <MjmlSection mjmlClass="section" key={`${key}-section`}>
        <MjmlColumn>
          <MjmlText fontWeight={qFontWeight} fontStyle={qFontStyle} color={qColor}>
            {"{{this.question}}"}
          </MjmlText>
          <MjmlText fontWeight={aFontWeight} fontStyle={aFontStyle} color={aColor}>
            {"{{this.answer}}"}
          </MjmlText>
          {showDivider && <MjmlDivider />}
        </MjmlColumn>
      </MjmlSection>
      <MjmlRaw key={`${key}-each-close`} dangerouslySetInnerHTML={{ __html: "{{/each}}" }} />
    </Fragment>
  );
}
